import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  display: none;\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  width: 100%;\n  height: ",
        ";\n  background-color: ",
        ";\n  border-top: solid 1px #ebebeb;\n  box-shadow: 0 7px 70px 0 rgba(0, 0, 0, 0.1);\n  z-index: 999;\n\n  @media (max-width: 1200px) {\n    display: block;\n  }\n\n  ul {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n\n    li {\n      flex: 1;\n      height: 100%;\n      text-align: center;\n\n      .active-link {\n        height: 100%;\n        text-align: center;\n        opacity: 0.35;\n\n        &.active {\n          opacity: 1;\n        }\n\n        > * {\n          display: block;\n        }\n        img,\n        svg {\n          margin: 8px auto 4px;\n        }\n\n        span {\n          display: block;\n          width: 100%;\n          font-size: 12px;\n          font-weight: bold;\n          color: ",
        ";\n          text-align: center;\n        }\n        @media (max-width: 1200px) {\n        }\n        @media (max-width: 768px) {\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled, { useTheme } from "styled-components";
import { observer } from "mobx-react-lite";
import React from "react";
import Image from "next/image";
import { themeGet } from "@styled-system/theme-get";
import { includesPath } from "@/lib/utils/url";
import { CATEGORY_PAGE, HOME_PAGE, LIBRARIES_INDEX_PAGE, LOGIN_PAGE, MOBILE_CATEGORY_PAGE, MYPAGE_PAGE, SHOP_CART_PAGE } from "@/settings/constant";
import { ActiveLink } from "@/components/ActiveLink";
import { useRouter } from "next/router";
import Icon from "@/components/icon/Icon";
import { Cart, Library } from "@/components/icon/IconList";
export const MobileOnlyHeaderHeight = "64px";
export const mobileTabBarHeight = "0";
const MobileTabBarWrapper = styled.div.withConfig({
    componentId: "sc-7026df3d-0"
})(_templateObject(), mobileTabBarHeight, themeGet("background.0", "#FDFDFF"), themeGet("text.0", "#1B1B29"));
export const MobileTabBar = observer((param)=>{
    let { isLogin  } = param;
    // const {status, actions} = useViewModel({}, MobileTabBarModel)
    const router = useRouter();
    const { pathname , query  } = router;
    const theme = useTheme();
    return /*#__PURE__*/ _jsx(MobileTabBarWrapper, {
        children: /*#__PURE__*/ _jsxs("ul", {
            children: [
                /*#__PURE__*/ _jsx("li", {
                    children: /*#__PURE__*/ _jsxs(ActiveLink, {
                        className: includesPath(pathname, HOME_PAGE) && !includesPath(pathname, MOBILE_CATEGORY_PAGE) && !includesPath(pathname, CATEGORY_PAGE) && !includesPath(pathname, SHOP_CART_PAGE) && !includesPath(pathname, LIBRARIES_INDEX_PAGE) && !includesPath(pathname, MYPAGE_PAGE) ? "active-link active" : "active-link",
                        href: "".concat(HOME_PAGE),
                        passHref: true,
                        children: [
                            /*#__PURE__*/ _jsx(Image, {
                                src: "/static/assets/ico-home.svg",
                                alt: "홈",
                                width: 24,
                                height: 24
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                children: "홈"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx("li", {
                    children: /*#__PURE__*/ _jsxs(ActiveLink, {
                        className: includesPath(pathname, SHOP_CART_PAGE) ? "active-link active" : "active-link",
                        href: isLogin ? SHOP_CART_PAGE : LOGIN_PAGE,
                        passHref: true,
                        children: [
                            /*#__PURE__*/ _jsx(Icon, {
                                icon: Cart
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                children: "장바구니"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx("li", {
                    children: /*#__PURE__*/ _jsxs(ActiveLink, {
                        className: includesPath(pathname, LIBRARIES_INDEX_PAGE) ? "active-link active" : "active-link",
                        href: isLogin ? LIBRARIES_INDEX_PAGE : LOGIN_PAGE,
                        passHref: true,
                        children: [
                            /*#__PURE__*/ _jsx(Icon, {
                                icon: Library
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                children: "라이브러리"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx("li", {
                    children: /*#__PURE__*/ _jsxs(ActiveLink, {
                        className: includesPath(pathname, MYPAGE_PAGE) ? "active-link active" : "active-link",
                        href: isLogin ? MYPAGE_PAGE : LOGIN_PAGE,
                        passHref: true,
                        children: [
                            /*#__PURE__*/ _jsx(Image, {
                                src: "/static/assets/ico-user-tabbar.svg",
                                alt: "마이페이지",
                                width: 24,
                                height: 24
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                children: "마이페이지"
                            })
                        ]
                    })
                })
            ]
        })
    });
});
